import axios from '@axios'

const state = () => ({
  branches: {
    meta: {
      pagination: {
        page: 1,
        per_page: 10,
        total_objects: 0,
      },
    },
    data: [],
  },
  branch: {},
})

const getters = {
  branches(state) {
    return state.branches.data
  },
  branch(state) {
    return state.branch
  },
}

const mutations = {
  SET_BRANCHES(state, payload) {
    state.branches = payload
  },
  SET_BRANCH(state, payload) {
    state.branch = payload
  },
}

const actions = {
  fetchAllBranches(context, { params = null } = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get('/v1/supplier_branches', {
          params,
        })
        .then(response => {
          context.commit('SET_BRANCHES', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  fetchBranches(context, { supplierId, params = null }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/v1/suppliers/${supplierId}/supplier_branches`, {
          params,
        })
        .then(response => {
          context.commit('SET_BRANCHES', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  addBranch(context, { supplierId, supplierBranch }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/v1/suppliers/${supplierId}/supplier_branches`, {
          supplier_branch: supplierBranch,
        })
        .then(response => {
          context.dispatch('fetchCategories')
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  fetchBranch(context, { supplierId, branchId }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/v1/suppliers/${supplierId}/supplier_branches/${branchId}`)
        .then(response => {
          context.commit('SET_BRANCH', response.data)
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  editBranch(context, { branch, branchId, supplierId }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/v1/suppliers/${supplierId}/supplier_branches/${branchId}`, {
          supplier_branch: branch,
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  setBranchExpress(context, { branchId, supplierId, is_express }) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          `/v1/suppliers/${supplierId}/supplier_branches/${branchId}/change_is_express`,
          { supplier_branch: { is_express } },
        )
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  updateBranchDeliveryTimeHours(context, { supplierId, branchId, delivery_time_hours }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/v1/suppliers/${supplierId}/supplier_branches/${branchId}`, {
          supplier_branch: { delivery_time_hours },
        })
        .then(response => {
        // actualiza la branch actual en el state
          context.commit('SET_BRANCH', response.data)

          // OPCIONAL: si quieres reflejarlo también en branches.data (listado)
          const updated = response.data
          const idx = context.state.branches.data.findIndex(b => b.id === updated.id)
          if (idx !== -1) {
            const copy = [...context.state.branches.data]
            copy.splice(idx, 1, updated)
            context.commit('SET_BRANCHES', { ...context.state.branches, data: copy })
          }

          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
